<template>
     <div class="modal fade " id="language-modal-deposit" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog onload-modal  modal-dialog-centered">
         <div class="modal-content">
            <div class="modal-header border-0">
               <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
               <div class="modal-info">
                  <img loading="lazy" src="@/assets/images/modal-info-icon.webp" alt="modal-info-icon">
               </div>
               <section class="sub-header-wrapper mt-3">

                  <div class="sub-header-tab">
                        <ul class="nav nav-pills" id="pills-tab" role="tablist">
                           <li class="nav-item" role="presentation">
                              <button class="nav-link active" id="pills-language1-tab" data-bs-toggle="pill"
                                 data-bs-target="#pills-language1" type="button" role="tab" aria-controls="pills-language1"
                                 aria-selected="true">English</button>
                           </li>
                           <li class="nav-item" role="presentation">
                              <button class="nav-link" id="pills-language2-tab" data-bs-toggle="pill"
                                 data-bs-target="#pills-language2" type="button" role="tab" aria-controls="pills-language2"
                                 aria-selected="false">हिंदी</button>
                           </li>
                           <li class="nav-item" role="presentation">

                              <button class="nav-link" id="pills-language3-tab" data-bs-toggle="pill"
                                 data-bs-target="#pills-language3" type="button" role="tab" aria-controls="pills-language3"
                                 aria-selected="false">దయచేసి </button>
                           </li>
                           <li class="nav-item" role="presentation">
                              <button class="nav-link" id="pills-language4-tab" data-bs-toggle="pill"
                                 data-bs-target="#pills-language4" type="button" role="tab" aria-controls="pills-language4"
                                 aria-selected="false">অনুগ্রহ </button>
                           </li>

                           <li class="nav-item" role="presentation">
                              <button class="nav-link" id="pills-language5-tab" data-bs-toggle="pill"
                                 data-bs-target="#pills-language5" type="button" role="tab" aria-controls="pills-Statement"
                                 aria-selected="false">ಬೇರೆ </button>
                           </li>


                        </ul>
                  </div>

                  <div class="sub-header-tab-con">
                        <div class="tab-content" id="pills-tabContent">

                           <div class="tab-pane fade show active" id="pills-language1" role="tabpanel"
                              aria-labelledby="pills-language1-tab">
                              <div class="language-list">
                                 <ul>
                                    <li>Please only make deposits to the accounts listed on the next screen.</li>
                                    <li>Deposits made to any other account may not be credited to yours.</li>
                                 </ul>
                              </div>
                           </div>


                           <div class="tab-pane fade  " id="pills-language2" role="tabpanel"
                              aria-labelledby="pills-language2-tab">
                              <div class="language-list">
                                 <ul>
                                    <li>कृपया अगली स्क्रीन पर सूचीबद्ध खातों में ही जमा करें।</li>
                                    <li> किसी अन्य खाते में किए गए जमा को आपके खाते में जमा नहीं किया जा सकता है।</li>
                                 </ul>
                              </div>
                           </div>

                           <div class="tab-pane fade " id="pills-language3" role="tabpanel"
                              aria-labelledby="pills-language3-tab">
                              <div class="language-list">
                                 <ul>
                                    <li>దయచేసి తదుపరి స్క్రీన్‌లో జాబితా చేయబడిన ఖాతాలకు మాత్రమే డిపాజిట్లు చేయండి.</li>
                                    <li> మరే ఇతర ఖాతాకు చేసిన డిపాజిట్లు మీ ఖాతాకు జమ చేయబడవు.</li>
                                 </ul>
                              </div>
                           </div>

                           <div class="tab-pane fade  " id="pills-language4" role="tabpanel"
                              aria-labelledby="pills-language4-tab">
                              <div class="language-list">
                                 <ul>
                                    <li>অনুগ্রহ করে শুধুমাত্র পরবর্তী স্ক্রিনে তালিকাভুক্ত অ্যাকাউন্টে জমা করুন।</li>
                                    <li> অন্য কোনো অ্যাকাউন্টে জমা করা আপনার অ্যাকাউন্টে জমা নাও হতে পারে।</li>
                                 </ul>
                              </div>
                           </div>

                           <div class="tab-pane fade  " id="pills-language5" role="tabpanel"
                              aria-labelledby="pills-language5-tab">
                              <div class="language-list">
                                 <ul>
                                    <li>దయచేసి తదుపరి స్క్రీన్‌లో జాబితా చేయబడిన ఖాతాలకు మాత్రమే డిపాజిట్లు చేయండి.</li>
                                    <li> మరే ఇతర ఖాతాకు చేసిన డిపాజిట్లు మీ ఖాతాకు జమ చేయబడవు.</li>
                                 </ul>
                              </div>
                           </div>

                        </div>
                     </div>
               </section>

            </div>
            <div class="modal-footer border-0">
               <button type="button" class="thm-but border-0 w-100" data-bs-dismiss="modal">Close</button>
            </div>
         </div>
      </div>
  </div>
</template>
<script>
export default {
   name: "LanguageModal"
}
</script>